import { ITableField } from '@/shared/Tables/Table'
import { IEquipment } from '@/pages/Equipment/equipment.types.ts'
import EquipmentStatus from 'src/pages/Equipment/components/Common/EquipmentStatus'
import EquipmentOrganizationsTableField from '@/pages/Equipment/components/Tables/EquipmentTable/EquipmentOrganizationsTableField'
import EquipmentModelsTags from '@/pages/Equipment/pages/EquipmentModels/components/EquipmentModelsTags'
import equipmentUtils from '@/pages/Equipment/equipment.utils'
import timeUtils from '@/utils/time.utils'

const equipmentTableAdminFields: ITableField<IEquipment, keyof IEquipment | 'address'>[] = [
  {
    key: 'address',
    clientSideOrdering: true,
    width: '300px',
    header: 'Адрес',
    getter: (it) => equipmentUtils.getEquipmentAddress(it.location),
    sortGetter: (it) => equipmentUtils.getEquipmentAddress(it.location),
  },
  {
    key: 'state',
    clientSideOrdering: true,
    width: '100px',
    header: 'Статус',
    getter: (it) => <EquipmentStatus equipment={it} />,
    sortGetter: (it) => it.state,
  },
  {
    key: 'organizations',
    clientSideOrdering: true,
    width: '150px',
    header: 'Организация',
    getter: (it) => <EquipmentOrganizationsTableField organizations={it.organizations} />,
    sortGetter: (it) => it.state,
  },
  {
    key: 'modelId',
    clientSideOrdering: true,
    width: '150px',
    header: 'Модель',
    getter: (it) => (it.modelId ? <EquipmentModelsTags ids={[it.modelId]} /> : '-'),
    sortGetter: (it) => it.modelId,
  },
  {
    key: 'connectionConfiguration',
    clientSideOrdering: true,
    width: '150px',
    header: 'ID контроллера',
    getter: (it) => it.connectionConfiguration?.controllerId || '-',
    sortGetter: (it) => it.connectionConfiguration?.controllerId || '-',
  },
]

const equipmentTableUserFields: ITableField<IEquipment, keyof IEquipment | 'address'>[] = [
  {
    key: 'address',
    clientSideOrdering: true,
    width: '300px',
    header: 'Адрес',
    getter: (it) => equipmentUtils.getEquipmentAddress(it.location),
    sortGetter: (it) => equipmentUtils.getEquipmentAddress(it.location),
  },
  {
    key: 'state',
    clientSideOrdering: true,
    width: '100px',
    header: 'Статус',
    getter: (it) => <EquipmentStatus equipment={it} />,
    sortGetter: (it) => it.state,
  },
  {
    key: 'modelId',
    clientSideOrdering: true,
    width: '150px',
    header: 'Модель',
    getter: (it) => (it.modelId ? <EquipmentModelsTags ids={[it.modelId]} /> : '-'),
    sortGetter: (it) => it.modelId,
  },
  {
    key: 'lastMaintenanceDate',
    clientSideOrdering: true,
    width: '150px',
    header: 'Последнее обслуживание',
    getter: (it) => timeUtils.formatDate(it.lastMaintenanceDate, 'dd MMM yyyy') || '-',
    sortGetter: (it) => it.state,
  },

  {
    key: 'description',
    clientSideOrdering: true,
    width: '150px',
    header: 'Комментарий',
    getter: (it) => it.connectionConfiguration?.description || '-',
    sortGetter: (it) => it.connectionConfiguration?.description || '-',
  },
]

export default {
  admin: equipmentTableAdminFields,
  user: equipmentTableUserFields,
}
